import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import logo from "../../assets/footer_logo.svg";
import heroBg from "../../assets/solar.png"; // update path

const Footer = () => {
  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      {/* 🔥 HERO CTA (UNCHANGED CLASS NAMES) */}
      <section className="home-hero">
        <div className="home-hero-content">
          <h1 className="home-hero-title">
            Ready To Simplify Your
            <br />
            Solar Journey?
          </h1>

          <p className="home-hero-subtitle">
            Tell us your requirement — our experts will design a complete solar
            and energy roadmap tailored to your business, institution, or home.
          </p>

          <button className="home-hero-btn" onClick={() => goTo("/contact")}>
            Book A Free Call
          </button>
        </div>

        <div className="home-hero-img-wrap">
          <img src={heroBg} alt="Solar CTA" className="home-hero-img" loading="lazy" />
        </div>
      </section>

      {/* FOOTER LINKS */}
      <div className="footer-top">
        <div className="footer-col">
          <p className="footer-col-heading">NATIONAL SOLAR PROGRAMS</p>
          <ul>
            <li onClick={() => goTo("/pm-kusum")}>PM-KUSUM Program</li>
            <li onClick={() => goTo("/rooftop-solar")}>
              PM Surya Ghar Rooftop Yojana
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <p className="footer-col-heading">CORPORATE ENERGY MODELS</p>
          <ul>
            <li onClick={() => goTo("/captive-model")}>Captive Power Model</li>
            <li onClick={() => goTo("/group-captive")}>Group Captive Model</li>
            <li onClick={() => goTo("/open-access")}>Open Access Solar</li>
          </ul>
        </div>

        <div className="footer-col">
          <p className="footer-col-heading">ROOFTOP SOLAR SOLUTIONS</p>
          <ul>
            <li onClick={() => goTo("/commercial-rooftop")}>
              Commercial & Industrial Rooftop
            </li>
            <li onClick={() => goTo("/residential-rooftop")}>
              Residential Rooftop Systems
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <p className="footer-col-heading">TRUECARE 360</p>
          <ul>
            <li onClick={() => goTo("/truetrack")}>TrueTrack</li>
            <li onClick={() => goTo("/truecare")}>TrueCare</li>
            <li onClick={() => goTo("/truecom")}>TrueCom</li>
          </ul>
        </div>

        <div className="footer-col">
          <p className="footer-col-heading">&nbsp;</p>
          <ul>
            <li onClick={() => goTo("/carbon-credits")}>
              Carbon Credits & Assets
            </li>
            <li onClick={() => goTo("/about")}>About</li>
            <li onClick={() => goTo("/privacy-policy")}>Privacy Policy</li>
            <li onClick={() => goTo("/terms-and-conditions")}>Terms & Conditions</li>
          </ul>
        </div>
      </div>

      {/* LOGO */}
      <div className="footer-logo-wrap">
        <img
          src={logo}
          alt="True Renewables Logo"
          className="footer-logo-img"
          loading="lazy"
        />
      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        <p className="footer-copy">
          © True Renewables 2026 | All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
